
      export default {
        mounted() {
          this.minHeight = 40
          this.maxHeight = 200
          this.autoResize()

          this.el.addEventListener("input", () => this.autoResize())
          this.el.addEventListener("keydown", (e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault()
              const form = document.getElementById(this.el.dataset.formId)
              if (form && this.el.value.trim()) {
                form.requestSubmit()
              }
            }
          })
        },
        updated() {
          this.autoResize()
          // Focus input when it becomes enabled (after agent completes)
          if (!this.el.disabled && this.wasDisabled) {
            this.el.focus()
          }
          this.wasDisabled = this.el.disabled
        },
        autoResize() {
          this.el.style.height = "auto"
          const newHeight = Math.min(Math.max(this.el.scrollHeight, this.minHeight), this.maxHeight)
          this.el.style.height = newHeight + "px"
          this.el.style.overflowY = this.el.scrollHeight > this.maxHeight ? "auto" : "hidden"
        }
      }
    